import TabInOut from './TabInOut';

export default TabInOut;
